export const IFRAME_SANDBOX =
    "allow-scripts allow-forms allow-same-origin allow-modals allow-downloads allow-popups allow-presentation";
